(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsManageForm', rmsManageForm);

    function rmsManageForm() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=',
            },
            templateUrl: 'common/app/components/manage-form/manage-form',
            link: function(scope, elem, attr,ctrl) {
                ctrl.$render = function() {
                    scope.model = ctrl.$viewValue;
                }
            }
        };
    }
})();